export default "__VITE_ASSET__a14b4eab__"